import React from "react";

const RoleManagementList = React.lazy(() => import('src/pages/role_management/RoleManagementList'));
const AddRoleManagement = React.lazy(() => import('src/pages/role_management/AddRoleManagement'));
const EditRoleManagement = React.lazy(() => import('src/pages/role_management/EditRoleManagement'));

const routes = [
    { path: '/dashboard/role-management-list/add', name: 'Add', element: AddRoleManagement },
    { path: '/dashboard/role-management-list/edit', name: 'Edit', element: EditRoleManagement },
    { path: '/dashboard/role-management-list', name: 'Roles & Permissions', element: RoleManagementList },
];

export default routes;
